const HOST = process.env.HOSTNAME || window.location.host;
const PROTOCOL = window.location.protocol;

export default {
    api: {
        vezetvsem: {
            url: `//${HOST}/api`,
            key: 'dy6bW8D1yEFjk1PsrAKNAfnLNfVWJNOiwusUk2a5',
        },
    },
    ga: {
        tracking: 'UA-18075654-1',
    },
    yandex_map: {
        key: '',
    },
    google_api: {
        api_key: 'AIzaSyC-904DvpRqqIMNoLycCaGqGHA_uPRzFJI',
    },
    social: {
        yandex: {
            client_id: 'dd66dd9b44124cb080ea40e285c9af31',
        },
        google: {
            client_id: '295608474853-lei4d18na48th5rfs7rrtleg7bcji279.apps.googleusercontent.com',
            redirect_uri: `${PROTOCOL}//${HOST}/booking/social_auth/google`,
        },
        facebook: {
            client_id: '297445750366171',
            redirect_uri: `${PROTOCOL}//${HOST}/booking/social_auth/facebook`,
        },
        mailru: {
            client_id: '743449',
            redirect_uri: `${PROTOCOL}//${HOST}/booking/social_auth/mailru`,
        },
        ok: {
            client_id: '94011136',
            redirect_uri: `${PROTOCOL}//${HOST}/booking/social_auth/ok`,
        },
        vk: {
            client_id: '4020835',
            redirect_uri: `${PROTOCOL}//${HOST}/booking/social_auth/vk`,
        },
    },
    lang: 'ru',
    israel_hosts: [
        'vezet-vsem.ru',
        'www.vezet-vsem.ru',
        'movan.co.il',
        'www.movan.co.il',
    ],
    facebook_pixel: {
        id: '517499426732228',
    },
};



// WEBPACK FOOTER //
// ./configs/production/client.config.js